import * as types from '../mutation-types'
import api from '@/api'
import {Message} from 'element-ui'

const state = {
  users: []
}
const getters = {
  users: state => state.users
}
const actions = {
  
}
const mutations = {
  
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js